import React from 'react';


export const StudiesIcon = props => {
    return (
        <svg className={props.className} width="40" height="24" viewBox="0 0 40 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.9998 15.9966L8.06738 12.324V15.9372V18.4578C8.06738 21.2936 13.4115 23.5927 20.0034 23.5927C26.5949 23.5927 31.9399 21.2936 31.9399 18.4578C31.9399 18.4355 31.9326 18.4131 31.9322 18.3913V12.324L19.9998 15.9966Z"
                fill="black"/>
            <path
                d="M0 8.10167L4.26283 9.62654L4.6261 8.84852L6.19215 8.7154L6.41543 8.94774L5.07162 9.2664L4.87576 9.84609C4.8754 9.84609 1.84031 16.1913 2.28607 19.2954C2.28607 19.2954 4.18059 20.4255 6.07429 19.2954L6.57755 10.8085V10.102L9.39643 9.4661L9.19734 9.95637L7.0956 10.6398L8.06766 10.9871L20.0001 14.6597L31.9324 10.9871L40 8.10172L20.0001 0.407227L0 8.10167Z"
                fill="black"/>
        </svg>
    )
};
